<template>
    <div
        class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50"
        v-if="showing"
    >
        <div
            class="bg-gray-900 text-green-500 p-3 md:p-5 border-2 border-green-500 rounded-lg w-full max-w-5xl h-[80%] overflow-y-auto font-mono relative"
        >
            <div class="flex flex-col justify-center h-full text-center">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Station Menu</h2>
                <div class="flex flex-col gap-4">
                    <button
                        @click="$emit('select-train')"
                        class="bg-gray-700 text-white py-3 px-5 rounded text-xl hover:bg-gray-600"
                    >
                        Buy train tickets
                    </button>
                    <button
                        @click="$emit('select-bus')"
                        class="bg-gray-700 text-white py-3 px-5 rounded text-xl hover:bg-gray-600"
                    >
                        Buy bus tickets
                    </button>
                    <button
                        @click="$emit('close')"
                        class="bg-gray-700 text-white py-3 px-5 rounded text-xl hover:bg-gray-600"
                    >
                        Exit Station
                    </button>
                </div>
            </div>
        </div>
    </div>
  </template>
    
<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  station: {
    type: Object,
    required: false,
  },
  time: {
    type: Number,
    required: true,
  },
  dayOfWeek: {
    type: Number,
    required: true,
  },
});

const BaseUrl = ref(baseUrl);
const showing = defineModel('modelValue', { default: false, type: Boolean });
const emit = defineEmits(['select-train', 'select-bus', 'close']);

const showMenu = ref(true);

function close() {
  emit('close');
  showMenu.value = true;
}

function exitStation() {
  close();
}

</script>